<template>
  <div
    class="fix-alert--wrapper"
    :style="!type ? customStyle : []"
    :class="generateClassAndIcon()"
  >
    <span class="material-icons fix-alert--icon">
      {{ alertIcon }}
    </span>
    <span
      v-if="retryable && action && !retrying && !success"
      class="material-icons fix-alert--dismiss fix-alert--retry"
      @click="retryAction"
    >
      cached
    </span>

    <span
      class="material-icons fix-alert--dismiss"
      @click="removeAlert"
    >
      clear
    </span>
    <p class="fix-alert--message">
      {{ message }}
    </p>
    <span class="fix-alert--loading">
      <div v-if="retrying" />
      <span
        v-if="success"
        class="material-icons"
        style="font-size: 30px"
      >
        done
      </span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'MyAlert',
  props: {
    // Alert ID: String
    id: {
      type: String,
      required: true
    },
    // Alert Icon: String - Material Design Icon
    icon: {
      type: String,
      default: ''
    },
    // Alert Message: String
    message: {
      type: String,
      required: true
    },
    // Alert Background-Color: String
    color: {
      type: String,
      default: 'black'
    },
    // Alert Action which can be retried: Object { method: Function, params: Array }
    action: {
      default: () => {},
      type: Object
    },
    // Alert Text-Color: String
    text: {
      type: String,
      default: 'white'
    },
    // Alert Width - Number - In percentage
    width: {
      type: Number,
      default: 100
    },
    // Alert Height - Number - In pxs
    height: {
      type: Number,
      default: 75
    },
    // Alert Duration - Number - In Milliseconds
    duration: {
      type: Number,
      default: 2000
    },
    // Alert Retryable - Boolean
    retryable: {
      type: Boolean
    },
    // Alert Type - String - success/warning/error/light/dark
    type: {
      default: '',
      type: String
    }
  },
  data () {
    return {
      retrying: false,
      success: false,
      alertIcon: ''
    }
  },
  computed: {
    classGetter () {
      return this.$store.state.alertModule.alertsTheme
    },
    customStyle () {
      let styles = []
      if (this.text) {
        styles.push({ color: this.text })
      }
      if (this.color) {
        styles.push({ 'background-color': this.color })
      }
      return styles
    }
  },
  methods: {
    // Generate the class to
    generateClassAndIcon () {
      let globalClass = this.classGetter[this.type]
      switch (this.type) {
        case 'light':
          return globalClass || 'lightClass'
        case 'dark':
          return globalClass || 'darkClass'
        case 'warning':
          this.icon ? this.alertIcon = this.icon : this.alertIcon = 'warning'
          return globalClass || 'warningClass'
        case 'error':
          this.icon ? this.alertIcon = this.icon : this.alertIcon = 'error'
          return globalClass || 'errorClass'
        case 'success':
          this.icon ? this.alertIcon = this.icon : this.alertIcon = 'done_outline'
          return globalClass || 'successClass'
        default:
          return ''
      }
    },
    // Retry action if a method is available
    retryAction () {
      this.retrying = true
      if (this.action.method) {
        this.$retryAction(this.id)
      }
    },
    // Call the removeAlert global method
    removeAlert () {
      this.$removeAlert(this.id)
    }
  }
}
</script>

<style scoped>

.fix-alert--wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 20px;
  min-height: 75px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05), 0 1px 2px rgba(0,0,0,0.04);
  transition: all 0.3s cubic-bezier(.25,.8,.25,1);
  text-align: center;
  margin-bottom: 1.5px;
}

.fix-alert--wrapper:hover {
  box-shadow: 0 5px 15px rgba(0,0,0,0.10), 0 5px 18px rgba(0,0,0,0.10);
}

.fix-alert--icon {
  font-size: 30px;
  position: absolute;
  left: 4%;
}

.fix-alert--dismiss {
  font-size: 27px;
  position: absolute;
  padding: 5px;
  right: 4%;
}

.fix-alert--dismiss:hover {
  cursor: pointer;
  background-color: #e8e8e8;
  border-radius: 50%;
  color: black;
}

.fix-alert--message {
  word-break: break-word;
  font-size: 110%;
  margin: 10px 50px;
  font-family: Roboto, 'sans-serif';
}

.fix-alert--retry {
  right: 15%
}

.fix-alert--retry:hover {
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(.25,.8,.25,1);
  color: black !important;
}

.fix-alert--loading {
  position: fixed;
  right: 15%;
}

.fix-alert--loading div {
  width: 30px;
  height: 30px;
  border: 6px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.errorClass {
  color: #ffffff;
  background-color: #ff322a;
}

.successClass {
  color: #ffffff;
  background-color: #1bce42;
}

.warningClass {
  color: #ffffff;
  background-color: #e8cf20;
}

.lightClass {
  color: #1b1b1b;
  background-color: #ffffff;
}

.darkClass {
  color: #ffffff;
  background-color: #1b1b1b;
}

</style>
